import React from "react";
import { useTranslation } from "react-i18next";

import { AccountSection } from "../components/AccountSection";
import { ChangePasswordSection } from "../components/ChangePasswordSection";

export default function ProfilePage() {
  const { t } = useTranslation();
  return (
    <div className="space-y-6" data-testid="profile-page">
      <header>
        <h1
          className="text-3xl font-semibold tracking-tight text-text-primary"
          data-testid="profile-title"
        >
          {t("profile.title")}
        </h1>
        <p className="mt-2 text-sm text-text-secondary">
          {t("profile.subtitle")}
        </p>
      </header>

      {/*
        A12: Saved-addresses section removed. The two remaining panels
        (account + password) stack in a single column on mobile and sit
        side-by-side on lg+ screens.
      */}
      <div className="grid gap-6 lg:grid-cols-2">
        <AccountSection />
        <ChangePasswordSection />
      </div>
    </div>
  );
}
